export default {
  login_account_login: 'Account Login',
  login_dynamicCode_login: 'Dynamic Code Login',
  login_input_username: 'Please enter username',
  login_input_password: 'Please enter password',
  login_input_mobilePhone: 'Please enter mobile phone number',
  login_input_verifyCode: 'Please enter dynamic verification code',
  login_input_code: 'Please enter verification code',
  login_remember_password: 'Remember password',
  login: 'Login',
  login_wechat_login: 'WeChat Quick Login',
  login_wechat_scan_login: 'Scan with WeChat to login',
  login_school_verify: 'Shaanxi Mingshan University Unified Identity Authentication',
  login_get_verify_code: 'Obtain',

  login_username_required: 'Username cannot be empty',
  login_password_required: 'Password cannot be empty',
  login_mobilePhone_required: 'Mobile phone number cannot be empty',
  login_mobilePhone_format: 'Please enter a valid mobile phone number format',
  login_verifyCode_required: 'Dynamic verification code cannot be empty',
  login_verifyCode_incorrect: 'Dynamic verification code is incorrect',
  login_code_required: 'Verification code cannot be empty',
  login_code_incorrect: 'Verification code is incorrect',
  login_later: 'Login later',
  login_with_wechat: 'Login with WeChat',
  login_with_account: 'Login with account',
}